import SelectGeneric from 'components/commons/form/SelectGeneric';
import { voidClaim } from 'feature/claims/claimSlice';
import { resetDialogConfirm } from 'feature/hooks/dialogSlice';
import {
	resetInputStore,
	setInputHandleChange,
} from 'feature/input/inputSlice';
import _ from 'lodash';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'store/store';
import { Button, Stack, TextField, Typography } from 'styles';
import palette from 'styles/theme/Palette';
import { TRANSLATION_KEYS } from 'utils/constants';
import { useTranslation } from 'utils/translations';

const ClaimVoidModalContent = () => {
	const dispatch = useDispatch<AppDispatch>();
	const { t: tClientLabels } = useTranslation('', {
		keyPrefix: TRANSLATION_KEYS.CLIENT_LABELS,
	});
	const { t: tDbLabels } = useTranslation('', {
		keyPrefix: TRANSLATION_KEYS.DB_LABELS,
	});
	const { reasonCodesVoid } = useSelector((store: RootState) => store.claim);
	const { reasonCode, reasonNote } = useSelector(
		(store: RootState) => store.input,
	);
	const [reasonError, setReasonError] = useState<boolean>(false);

	const { claimData: claim } = useSelector((store: RootState) => store.claim);
	useEffect(() => {
		return () => {
			dispatch(resetInputStore());
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const handleChangeSelect = (item: string) => {
		dispatch(setInputHandleChange({ name: 'reasonCode', value: item }));
		setReasonError(false);
	};

	const handleConfirm = () => {
		if (
			!_.isEmpty(reasonCode) &&
			(_.isNull(reasonNote) ||
				(_.isString(reasonNote) && reasonNote?.length <= 500))
		) {
			dispatch(voidClaim(claim.claimUUID!));
		} else if (_.isEmpty(reasonCode)) {
			setReasonError(true);
		}
	};

	return (
		<Stack minHeight={'390px'} justifyContent="space-between">
			<Stack gap={2}>
				<Typography variant="bodyLink">
					{tClientLabels('dialog.reason.subtitle')}
				</Typography>
				<SelectGeneric
					sx={{ mb: '22px' }}
					action={(payload: string) => handleChangeSelect(payload)}
					items={reasonCodesVoid.map(el => ({
						text: tDbLabels(`${el.label}`),
						value: el.code,
						id: 0,
					}))}
					name={'reason'}
					initialValue={reasonCode || ''}
					error={reasonError}
				/>
				<Stack sx={{ position: 'relative' }}>
					<TextField
						label={'Note'}
						name={'note'}
						multiline
						sx={{ height: 'auto', mb: '22px' }}
						rows={8}
						onChange={e =>
							dispatch(
								setInputHandleChange({ name: 'reasonNote', value: e.target.value }),
							)
						}
						value={reasonNote || ''}
						error={!!reasonNote && reasonNote.length > 500}
					/>
					{reasonNote && reasonNote.length > 500 && (
						<Typography
							variant="bodyLink"
							sx={{ position: 'absolute', bottom: 0 }}
							color={palette.error.main}
						>
							Text cannot be longer than 500 characters
						</Typography>
					)}
				</Stack>
				<Stack>
					<Typography variant="bodyLink" mb={0.5} textAlign={'right'}>
						{tClientLabels('dialog.reason.confirm', {
							code: claim.externalClaimId,
						})}
					</Typography>
				</Stack>
			</Stack>
			<Stack flexDirection={'row'} gap={1} justifyContent={'flex-end'}>
				<Button
					variant="outlined"
					sx={{
						width: 'fit-content',
					}}
					onClick={() => dispatch(resetDialogConfirm())}
				>
					{tClientLabels('commons.buttons.cancel')}
				</Button>
				<Button
					variant="contained"
					sx={{
						width: 'fit-content',
						backgroundColor: palette.black.main,
					}}
					onClick={handleConfirm}
				>
					{tClientLabels('commons.buttons.confirm')}
				</Button>
			</Stack>
		</Stack>
	);
};

export default ClaimVoidModalContent;
